<div *ngIf="displayError">
    <div class="error-msg" attr.aria-label="{{errorMsg}}"  aria-required="true">
        {{ errorMsg }}
    </div>
</div>